import { getUser } from "./user";
import * as grpcWeb from 'grpc-web';
import { logOut } from "./login";

export function getMetadata(): grpcWeb.Metadata | null {
    return {
        'X-Cloud-Trace-Context': createTraceId() + '/0;o=1'
    };
}

export function getAuthMetadata(): grpcWeb.Metadata | null {
    const user = getUser();
    if (!user) {
        logOut();
        return null;
    }
    
    return {
        'X-Cloud-Trace-Context': createTraceId() + '/0;o=1'
    };
}

export function convertErrorMessage(err: any): string {
    let message = '';
    if (err as grpcWeb.Error) {
        message = err.message;
    } else if (err instanceof Error) {
        message = err.message;
    } else if (typeof err == 'string') {
        message = err;
    } else {
        return 'Internal RPC error';
    }

    if (message === 'unknown error') {
        return 'Could not connect to the server'
    }

    return message;
}

export function createTraceId(): string {
    let result = '';
    for (let i = 0; i < 16; i++) {
        const digit = Math.floor(Math.random() * 255);
        if (digit < 16) {
            result += '0';
        }
        result += digit.toString(16);
    }
    return result;
 }